import {useEffect, useMemo, useState} from 'react'
import {debounce} from '../../pages/search/utils'

/**
 * Returns `value` debounced by `delay` ms (default 300). Built on the pure `debounce` helper so the
 * timing behaviour is unit-tested there. Cancels the pending update on unmount / delay change.
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState<T>(value)

  const scheduler = useMemo(() => debounce((v: T) => setDebounced(v), delay), [delay])

  useEffect(() => {
    scheduler(value)
    return () => scheduler.cancel()
  }, [value, scheduler])

  return debounced
}
